import * as Sentry from '@sentry/react'

export const measureClientPerformance = (name: string) => {
  const start = performance.now()
  return {
    end: () => {
      const duration = performance.now() - start
      Sentry.addBreadcrumb({
        category: 'client_performance',
        message: name,
        level: 'info',
        data: { duration }
      })
      return duration
    }
  }
}

export const trackWebVitals = () => {
  // Track First Contentful Paint
  const fcp = performance.getEntriesByName('first-contentful-paint')[0]
  if (fcp) {
    Sentry.addBreadcrumb({
      category: 'performance',
      message: 'First Contentful Paint',
      level: 'info',
      data: { duration: fcp.startTime }
    })
  }

  // Track Largest Contentful Paint
  const lcp = performance.getEntriesByName('largest-contentful-paint')[0]
  if (lcp) {
    Sentry.addBreadcrumb({
      category: 'performance',
      message: 'Largest Contentful Paint',
      level: 'info',
      data: { duration: lcp.startTime }
    })
  }

  // Track Time to Interactive
  const tti = performance.now()
  Sentry.addBreadcrumb({
    category: 'performance',
    message: 'Time to Interactive',
    level: 'info',
    data: { duration: tti }
  })
} 